<script>
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';
import InboxesAPI from 'dashboard/api/inboxes';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'OutboundMediaSettings',
  components: { SettingsToggleSection },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allowAttachments: false,
      allowAudio: false,
      isInitializing: true,
      isSaving: false,
      pendingSave: false,
      saveTimer: null,
    };
  },
  watch: {
    'inbox.id': {
      handler(inboxId) {
        this.loadSettings(inboxId);
      },
      immediate: true,
    },
    allowAttachments() {
      this.scheduleSave();
    },
    allowAudio() {
      this.scheduleSave();
    },
  },
  beforeUnmount() {
    clearTimeout(this.saveTimer);
  },
  methods: {
    async loadSettings(inboxId) {
      if (!inboxId) return;
      this.isInitializing = true;
      try {
        const response = await InboxesAPI.show(inboxId);
        const inbox = response.data;
        this.allowAttachments = inbox.allow_attachments === true;
        this.allowAudio = inbox.allow_audio === true;
        this.$store.commit('inboxes/EDIT_INBOXES', inbox);
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.OUTBOUND_MEDIA.ERROR'));
      } finally {
        this.$nextTick(() => {
          this.isInitializing = false;
        });
      }
    },
    scheduleSave() {
      if (this.isInitializing || !this.inbox.id) return;
      clearTimeout(this.saveTimer);
      this.saveTimer = setTimeout(() => this.saveSettings(), 250);
    },
    async saveSettings() {
      if (this.isSaving) {
        this.pendingSave = true;
        return;
      }
      this.isSaving = true;
      try {
        const response = await InboxesAPI.update(this.inbox.id, {
          allow_attachments: this.allowAttachments,
          allow_audio: this.allowAudio,
        });
        this.$store.commit('inboxes/EDIT_INBOXES', response.data);
      } catch (error) {
        this.isInitializing = true;
        this.allowAttachments = this.inbox.allow_attachments === true;
        this.allowAudio = this.inbox.allow_audio === true;
        this.$nextTick(() => {
          this.isInitializing = false;
        });
        useAlert(this.$t('INBOX_MGMT.OUTBOUND_MEDIA.ERROR'));
      } finally {
        this.isSaving = false;
        if (this.pendingSave) {
          this.pendingSave = false;
          this.saveSettings();
        }
      }
    },
  },
};
</script>

<template>
  <div class="my-6 flex flex-col gap-3">
    <SettingsToggleSection
      v-model="allowAttachments"
      :header="'Permitir envio de anexos?'"
      :description="'Exibe ou oculta o botão de anexos nas respostas desta caixa.'"
    />
    <SettingsToggleSection
      v-model="allowAudio"
      :header="'Permitir envio de áudio?'"
      :description="'Exibe ou oculta o botão de gravação de áudio nas respostas desta caixa.'"
    />
  </div>
</template>
